import React, { useContext } from "react";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import { Button } from "antd";
import { AuthContext } from "../../../contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import question_icon from "../../../assets/images/question.png";
import axios from "axios";


const DeleteMaquina = (props) => {
    const location = useLocation();
    let navigate = useNavigate();

    const {
        setDataUser,
        authInfo,
        setNotiMessage
    } = useContext(AuthContext);

    const isLoading = false;  

    const token = authInfo?.dataUser?.token;

    const { id } = useParams();

    const deleteHandler = () => {

        let config = {
            method: 'delete',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_SERVIDOR}/maquina-cliente`,
            headers: {
                'x-access-token': token,
                'Content-Type': 'application/json'
            },
            data: { id }
        };


        axios.request(config)
            .then(res => {
                setNotiMessage({
                    type: 'success',
                    message: 'Deleted Successfully.'
                })
                navigate("/dashboard-maquinas")
            })
            .catch(err => {

                if ([401, 403].includes(err.response.status)) {
                    setNotiMessage({
                        type: 'error', message: 'Delete Failed'
                    })
                    setDataUser(null);
                }
            })
    }

    return (
        <div className="Editar_container">
            {isLoading && <LoadingAction />}
            <div className="Editar_Content">
                <img className="Editar_Icon" src={question_icon} alt="question icon" />
                <p className="Editar_Text">Deseja excluir essa máquina?</p>
                <div className="Editar_Btns">
                    <Button className="Botao-Cancelar" onClick={() => {
                        navigate(`/pagamentos/${id}`, { state: location.state })
                    }}>

                        <span>NÃO</span>
                    </Button>  <Button className="Editar_Delete_Btn" onClick={() => {
                        deleteHandler()
                    }}>

                        <span>SIM, EXCLUA</span>
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default DeleteMaquina;
